<template>
  <slot name="header_close" />
  <div class="container">
    <h4 class="title">{{ $t("dialog.welcome.whatsapp") }}</h4>
    <img class="image" src="@/assets/images/whatsapp_integration.png" />
  </div>
</template>

  <script>
</script>

  <style lang="scss" scoped>
.title {
  font-size: 1.3rem;
  text-transform: uppercase;
  text-align: center;
  text-wrap: balance;
  padding-inline: 20px;
}
.container {
  position: relative;
  font-family: Gilroy;
  font-size: 24px;
  font-weight: 500;
  color: var(--text-color);
  background-color: white;
  padding: 20px 28px 10px;
  border-radius: 7px;
}
.image {
  min-width: 220px;
  width: 100%;
  max-width: 360px;
  margin: 0 auto;
}

@media (max-width: 580px) {
  .title {
    font-size: 1.1rem;
  }
  .image {
    padding-inline: 20px;
  }
}
@media (max-width: 400px) {
  .title {
    font-size: 0.8rem;
    padding: 0 20px;
  }
}
</style>
